module.exports = __webpack_public_path__ + "img/loginBG1b.c54ae235.png";